import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS } from '../../redux/actions';
import { HeadersPath } from '../../Utils/ScreenPath';
import CustomDropdown from '../../Common/CustomDropdown';
import { FileQuestion, Lock } from 'lucide-react';
import { Button } from '../../Common/Button';
import ChapterSelector from '../../Common/ChapterSelector';
import Exam from '../../assets/images/Exam.png';
import bookmark from '../../assets/images/bookmark.png';
import clipboard from '../../assets/images/clipboard.png';
import task from '../../assets/images/task.png'
import book from '../../assets/images/book.png';
import clipboardTick from "../../assets/images/clipboardTick.png"
import { ErrorToast } from '../../Common/Toast';
import { Api } from '../../Service/api';
import moment from 'moment';
import PrintModel from '../../Common/PrintModel';
import SubjectPurchase from '../../Common/SubjectPurchase';
import { madeFinalObject } from '../../helper/madeFinalObject';
import { dynamicSequence } from '../../helper/dynamicSequence';

const AutoGenerate = () => {
  const dispatch = useDispatch();
  const selectedData = useSelector((state) => state?.SelectedDetail?.Data);
  const boardDataList = useSelector((state) => state?.Board?.BoardData || {});
  const mediumDataList = useSelector(
    (state) => state?.Medium?.MediumData || {}
  );
  const standardDataList = useSelector(
    (state) => state?.StandardAuto?.StandardAutoData || {}
  );
  const semesterDataList = useSelector(
    (state) => state?.SemesterAuto?.SemesterAutoData || {}
  );
  const subjectDataList = useSelector(
    (state) => state?.SubjectAuto?.SubjectAutoData || {}
  );

  const [selectedDrpData, setSelectedDrpData] = useState({
    board: "",
    medium: "",
    standard: "",
    semester: "",
    subject: "",
    marks: "",
    chapter: [],
    isBluePrint: { name: "No", id: "2", isbluprints: "false", isautos: "true" },
  });

  const [selectedChapters, setSelectedChapters] = useState([]);
  const [boardData, setBoardData] = useState([]);
  const [mediumData, setMediumData] = useState([]);
  const [standardData, setStandardData] = useState([]);
  const [semesterData, setSemesterData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [marksData, setMarksData] = useState([]);
  const [blueMarksData, setBlueMarksData] = useState([]);
  const [chapterData, setChapterData] = useState({});
  const [modelCall, setModelCall] = useState(false);
  const [isModelOpen, setisModelOpen] = useState(false);
  const [isPurchaseModelOpen, setIsPurchaseModelOpen] = useState(false);


  let buttonDisabled =
    selectedDrpData?.isBluePrint?.name == "Yes"
      ? selectedDrpData?.board &&
        selectedDrpData?.medium &&
        selectedDrpData?.standard &&
        selectedDrpData?.subject &&
        selectedDrpData?.semester &&
        selectedDrpData?.marks
        ? false
        : true
      : selectedDrpData?.board &&
        selectedDrpData?.medium &&
        selectedDrpData?.standard &&
        selectedDrpData?.subject &&
        selectedDrpData?.semester &&
        selectedDrpData?.marks &&
        selectedChapters.length > 0
        ? false
        : true;

  const handleDropDownChange = (name, value) => {
    setSelectedDrpData({ ...selectedDrpData, [name]: value });
    if (name === "board") {
      setSelectedDrpData((prev) => ({
        ...prev,
        medium: "",
        standard: "",
        semester: "",
        subject: "",
        marks: "",
        [name]: value,
      }));
      setMediumData([]);
      setStandardData([]);
      setSemesterData([]);
      setSubjectData([]);
      setMarksData([]);
      setBlueMarksData([]);
      setChapterData({});
      setSelectedChapters([]);
    }

    if (name === "medium") {
      let payload = {
        ...selectedDrpData,
        standard: "",
        semester: "",
        subject: "",
        marks: "",
        [name]: value,
      };
      setSelectedDrpData(payload);
      setStandardData([]);
      setSemesterData([]);
      setSubjectData([]);
      setMarksData([]);
      setBlueMarksData([]);
      setChapterData({});
      setSelectedChapters([]);
    }

    if (name === "standard") {
      let payload = {
        ...selectedDrpData,
        semester: "",
        subject: "",
        marks: "",
        [name]: value,
      };
      setSelectedDrpData(payload);
      setSemesterData([]);
      setSubjectData([]);
      setMarksData([]);
      setBlueMarksData([]);
      setChapterData({});
      setSelectedChapters([]);
    }

    if (name === "semester") {
      let payload = {
        ...selectedDrpData,
        subject: "",
        marks: "",
        [name]: value,
      };
      setSelectedDrpData(payload);
      setSubjectData([]);
      setMarksData([]);
      setBlueMarksData([]);
      setChapterData({});
      setSelectedChapters([]);
    }

    if (name === "subject") {
      let payload = {
        ...selectedDrpData,
        marks: "",
        [name]: value,
      };
      setSelectedDrpData(payload);
      setMarksData([]);
      setChapterData({});
      setBlueMarksData([]);
      setSelectedChapters([]);
    }

    if (name === "marks") {
      let payload = {
        ...selectedDrpData,
        [name]: value,
      };
      setSelectedDrpData(payload);
    }

    if (name === "isBluePrint") {
      setSelectedDrpData((prev) => ({
        ...prev,
        board: "",
        medium: "",
        standard: "",
        semester: "",
        subject: "",
        marks: "",
        [name]: value,
      }));
      setMediumData([]);
      setStandardData([]);
      setSemesterData([]);
      setSubjectData([]);
      setMarksData([]);
      setBlueMarksData([]);
      setChapterData({});
      setSelectedChapters([]);
    }
  };



  const chapters = {
    isLocked: true,
    data: [
      { id: "1", chapter: "માહિતીનું એકત્રિકીકરણ ", chapter_no: "પ્રકરણ 1 " },
      { id: "2", chapter: "માહિતીનું નિરૂપણ  ", chapter_no: "પ્રકરણ 2 " },
      { id: "3", chapter: "મધ્યવર્તી સ્થિતિનાં માપ ", chapter_no: "પ્રકરણ 3 " },
      { id: "4", chapter: "પ્રસારમાન", chapter_no: "પ્રકરણ 4 " },
      { id: "5", chapter: "આવૃતિ - વિતરણની વિષમતા ", chapter_no: "પ્રકરણ 5 " },
    ],
  };

  const handleSelectionChange = (selectedChapters) => {
    // selectedDrpData((prev) => ({
    //     ...prev,
    //     chapter: selectedChapters
    // }))
    setSelectedChapters(selectedChapters);
  };

  const onIsLockedClick = (chapter) => {
    setIsPurchaseModelOpen(!isPurchaseModelOpen);
  };

  const handleModelClose = () => {
    setisModelOpen(!isModelOpen);
  };

  const onAutoGenerateClick = async () => {
    if (!buttonDisabled) {
      if (selectedDrpData?.isBluePrint?.name == "Yes" && chapterData?.isLocked) {
        setIsPurchaseModelOpen(true)
        return
      }
      dispatch(ACTIONS.startLoading())
      try {
        let res = {}
        let body = {
          standard: selectedDrpData?.standard?.id,
          subject: selectedDrpData?.subject?.id,
          semester: selectedDrpData?.semester?.id,
          tmarks: selectedDrpData?.marks?.tmarks,
          chapter: selectedChapters,
        }
        if (selectedDrpData?.isBluePrint?.name == "Yes") {
          const { data } = await Api.GenerateAutoPaperWithBluePrint(JSON.stringify(body))
          res = JSON.parse(data);
        } else {
          const { data } = await Api.GenerateAutoPaper(JSON.stringify(body))
          res = JSON.parse(data);
        }
        if (res?.status === 200) {
          let FinalObject = madeFinalObject(res?.data, false)
          let dataObject = dynamicSequence(FinalObject);
          if (res?.data.length > 0) {
            const data = {
              institute_logo: '',
              school_name: '',
              template_name: '',
              exam_name: '',
              chapter_name: '',
              exam_time: '',
              exam_marks: selectedDrpData?.marks?.tmarks,
              medium: selectedDrpData?.medium?.id,
              exam_date: moment(new Date()).format('DD/MM/YYYY'),
              paper_type: 'auto',
              genrate_type: 'with section',
              standard_id: selectedDrpData?.standard?.id,
              standard_name: selectedDrpData?.standard?.name,
              subject_id: selectedDrpData?.subject?.id,
              subject_name: selectedDrpData?.subject?.subject,
              semester_id: selectedDrpData?.semester?.id,
              semester_name: selectedDrpData?.semester?.semester,
              sections_info: dataObject,
            }
            dispatch(ACTIONS.getSelectedData(data))
            setisModelOpen(!isModelOpen)
            setModelCall(true)
          }
        }
      } catch (e) {
        ErrorToast(e);
      } finally {
        dispatch(ACTIONS.stopLoading())
      }
    }
  }

  const handleGetBoard = async () => {
    dispatch(ACTIONS.startLoading());
    try {
      let params = {
        isOthers: true,
      };
      dispatch(ACTIONS.getBoardData(params));
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const handleGetMedium = async () => {
    dispatch(ACTIONS.startLoading());
    try {
      let params = {
        board: selectedDrpData?.board?.id,
        isOthers: true,
      };
      dispatch(ACTIONS.getMediumData(params));
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };



  const handleGetAutoStandard = async () => {
    dispatch(ACTIONS.startLoading());
    try {
      let params = {
        medium: selectedDrpData?.medium?.id,
        board: selectedDrpData?.board?.id,
        isbluprint: selectedDrpData?.isBluePrint?.name == "Yes",
        isauto: selectedDrpData?.isBluePrint?.name == "No",
      };

      dispatch(ACTIONS.getAutoStandardData(params));
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const handleGetAutoSemester = async () => {
    dispatch(ACTIONS.startLoading());
    try {
      let params = {
        standard: selectedDrpData?.standard?.id,
        medium: selectedDrpData?.medium?.id,
        board: selectedDrpData?.board?.id,
        isbluprint: selectedDrpData?.isBluePrint?.name == "Yes",
        isauto: selectedDrpData?.isBluePrint?.name == "No",
      };
      dispatch(ACTIONS.getAutoSemesterData(params));
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };


  const handleGetAutoSubject = async (semesterId) => {
    dispatch(ACTIONS.startLoading());
    try {
      let params = {
        standard: selectedDrpData?.standard?.id,
        semester: selectedDrpData?.semester?.id,
        medium: selectedDrpData?.medium?.id,
        board: selectedDrpData?.board?.id,
        isbluprint: selectedDrpData?.isBluePrint?.name == "Yes",
        isauto: selectedDrpData?.isBluePrint?.name == "No",
        // limit: 100,
        // Offset: 1,


      };
      dispatch(ACTIONS.getAutoSubjectData(params));
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const handleGetChapter = async () => {
    dispatch(ACTIONS.startLoading());
    try {
      let body = {
        standard: selectedDrpData?.standard?.id,
        semester: selectedDrpData?.semester?.id,
        subject: selectedDrpData?.subject?.id,
      };
      const { data } = await Api.GetChapter(body);
      const res = JSON.parse(data);
      if (res?.status === 200) {
        setChapterData(res);
      } else {
        ErrorToast(res?.message);
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const handleGetMarks = async () => {
    // dispatch(ACTIONS.startLoading())
    try {
      let body = {
        standard: selectedDrpData?.standard?.id,
        semester: selectedDrpData?.semester?.id,
        subject: selectedDrpData?.subject?.id,
      };
      const { data } = await Api.GetMarks(JSON.stringify(body));
      const res = JSON.parse(data);
      if (res?.status === 200) {
        setMarksData(res?.data);
      } else {
        ErrorToast(res?.message);
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      // dispatch(ACTIONS.stopLoading())
    }
  };

  const handleGetMarksData = async () => {
    // dispatch(ACTIONS.startLoading())
    try {

      let body = `?standard=${selectedDrpData?.standard?.id}&semester=${selectedDrpData?.semester?.id}&subject=${selectedDrpData?.subject?.id}`;
      const { data } = await Api.GetMarksData(body);
      const res = JSON.parse(data);
      if (res?.status === 200) {
        setBlueMarksData(res?.data);
      } else {
        ErrorToast(res?.message);
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      // dispatch(ACTIONS.stopLoading())
    }
  };

  useEffect(() => {
    if (boardDataList?.status === 200) {
      setBoardData(boardDataList);
    }
  }, [boardDataList]);

  useEffect(() => {
    // if(mediumDataList?.status === 200){
    setMediumData(mediumDataList);
    // }
  }, [mediumDataList]);

  useEffect(() => {
    if (standardDataList?.status === 200) {
      setStandardData(standardDataList);
    }
  }, [standardDataList]);

  useEffect(() => {
    if (semesterDataList?.status === 200) {
      setSemesterData(semesterDataList);
    }
  }, [semesterDataList]);

  useEffect(() => {
    if (subjectDataList?.status === 200) {
      setSubjectData(subjectDataList);
    }
  }, [subjectDataList]);

  useEffect(() => {
    if (selectedDrpData?.board) {
      handleGetMedium();
    }
  }, [selectedDrpData?.board]);

  useEffect(() => {
    if (selectedDrpData?.medium) {
      handleGetAutoStandard();
    }
  }, [selectedDrpData?.medium]);

  useEffect(() => {
    if (selectedDrpData?.standard) {
      handleGetAutoSemester();
    }
  }, [selectedDrpData?.standard]);

  useEffect(() => {
    if (selectedDrpData?.semester) {
      handleGetAutoSubject();
    }
  }, [selectedDrpData?.semester]);

  useEffect(() => {
    if (selectedDrpData?.subject) {

      handleGetMarks();
      handleGetMarksData();
      handleGetChapter();
    }
  }, [selectedDrpData?.subject]);

  useEffect(() => {
    dispatch(ACTIONS.getHeaderPath(HeadersPath.AutoGenerate));
    handleGetBoard();
  }, []);

  const onPaymentSuccess = () => {
    if (selectedDrpData?.subject) {
      handleGetMarks();
      handleGetMarksData();
      handleGetChapter();
    }
  };

  return (
    <div>
      <div
        style={{ color: "#DC0000", margin: "7px 0" }}
        className="lg:text-base text-sm "
      >
        સૂચના : ઓટો પેપર અને રેન્ડમ પેપર જનરેશન એ એક એક્સ્ટ્રા સુવિધા છે તેનો
        કોઈ અલગ થી ચાર્જ લેવામાં આવેલ નથી. (અંગ્રેજી, ગુજરાતી, સંસ્કૃત, હિન્દી,
        એકાઉન્ટ, એસ.પી. વગેરે વિષયમાં આ સુવિધા ઉપલબ્ધ નહીં મળે) વધારે માહિતી
        માટે 9712444548 પર સંપર્ક કરો.
      </div>

      <div className="flex flex-col gap-2 lg:gap-4 mb-3">
        <div className="w-full">
          <CustomDropdown
            title="Create with Blue Print"
            data={[
              { name: "Yes", id: 1, isBluePrint: true, isauto: false },
              { name: "No", id: 2, isBluePrint: false, isauto: false },
            ]}
            textKey="name"
            onSelect={(e) => handleDropDownChange("isBluePrint", e)}
            defaultValue={selectedDrpData?.isBluePrint?.name}
            icon={<FileQuestion />}
          />
        </div>
      </div>

      {selectedDrpData?.isBluePrint && (
        <>
          <div className="flex flex-col gap-2 lg:gap-4">
            <div className="flex flex-col lg:flex-row gap-2 lg:gap-4">
              <div className="w-full">
                <CustomDropdown
                  title="Select Board"
                  data={boardData?.data || []}
                  textKey="board_name"
                  onSelect={(e) => handleDropDownChange("board", e)}
                  defaultValue={
                    selectedDrpData?.board?.board_name || "Select Board"
                  }
                  icon={<img src={Exam} alt="Exam Icon" className="w-5 h-5" />}
                />
              </div>
              <div className="w-full">
                <CustomDropdown
                  title="Select Medium"
                  data={selectedDrpData?.board ? mediumData?.data : [] || []}
                  textKey="name"
                  onSelect={(e) => handleDropDownChange("medium", e)}
                  defaultValue={
                    selectedDrpData?.medium?.name || "Select Medium"
                  }
                  icon={
                    <img src={bookmark} alt="Exam Icon" className="w-5 h-5" />
                  }
                />
              </div>
              <div className="w-full">
                <CustomDropdown
                  title="Select Standard"
                  data={selectedDrpData?.medium ? standardData?.data : [] || []}
                  textKey="name"
                  onSelect={(e) => handleDropDownChange("standard", e)}
                  defaultValue={
                    selectedDrpData?.standard?.name || "Select Standard"
                  }
                  icon={
                    <img src={clipboard} alt="Exam Icon" className="w-5 h-5" />
                  }
                />
              </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-2 lg:gap-4">
              <div className="w-full">
                <CustomDropdown
                  title="Select Semester"
                  data={
                    selectedDrpData?.standard
                      ? semesterData?.data
                      : [] || []
                  }
                  rows={true}
                  textKey="semester"
                  onSelect={(e) => handleDropDownChange("semester", e)}
                  defaultValue={
                    selectedDrpData?.semester?.semester || "Select Semester"
                  }
                  icon={<img src={task} alt="task Icon" className="w-5 h-5" />}
                />
              </div>
              <div className="w-full">
                <CustomDropdown
                  title="Select Subject"
                  data={
                    selectedDrpData?.semester ? subjectData?.data : [] || []
                  }
                  textKey="subject"
                  onSelect={(e) => handleDropDownChange("subject", e)}
                  defaultValue={
                    selectedDrpData?.subject?.subject || "Select Subject"
                  }
                  icon={<img src={book} alt="book Icon" className="w-5 h-5" />}
                />
              </div>


              <div className="w-full">

                {console.log(selectedDrpData?.subject?.marksData, "mark")}
                <CustomDropdown
                  title="Select Mark"
                  data={
                    selectedDrpData?.isBluePrint?.name == "Yes"
                      ?
                      selectedDrpData?.subject
                        ? blueMarksData
                        : [] || []
                      : selectedDrpData?.subject
                        ? marksData
                        : [] || []
                  }
                  textKey="tmarks"
                  onSelect={(e) => handleDropDownChange("marks", e)}
                  defaultValue={selectedDrpData?.marks?.tmarks || "Select Mark"}
                  icon={
                    <img
                      src={clipboardTick}
                      alt="book Icon"
                      className="w-5 h-5"
                    />
                  }
                />
              </div>


              {/* <div className="w-full">
                <CustomDropdown
                  title="Select Mark"
                  data={
                    selectedDrpData?.isBluePrint?.name == "Yes"
                      ? [
                        { id: 1, tmarks: "50(પ્રથમ)" },
                        { id: 2, tmarks: "50(વાર્ષિક)" },
                        { id: 3, tmarks: "80(Basic)(પ્રથમ)" },
                        { id: 4, tmarks: "80(Basic)(વાર્ષિક)" },
                        { id: 5, tmarks: "80(Standard)(પ્રથમ)" },
                        { id: 6, tmarks: "80(Standard)(વાર્ષિક)" },
                        { id: 7, tmarks: "100(પ્રથમ)" },
                        { id: 8, tmarks: "100(વાર્ષિક)" },
                      ]
                      : selectedDrpData?.subject
                        ? marksData
                        : [] || []
                  }
                  textKey="tmarks"
                  onSelect={(e) => handleDropDownChange("marks", e)}
                  defaultValue={selectedDrpData?.marks?.tmarks || "Select Mark"}
                  icon={
                    <img
                      src={clipboardTick}
                      alt="book Icon"
                      className="w-5 h-5"
                    />
                  }
                />
              </div> */}
            </div>
          </div>

          {Object.keys(chapterData).length > 0 &&
            selectedDrpData?.isBluePrint?.name == "No" && (
              <div style={{ margin: "10px 0" }}>
                <h1
                  style={{ padding: "5px 0", fontWeight: "600" }}
                  className="lg:text-xl text-lg "
                >
                  Select Chapter for Generate Exam Paper
                </h1>
                <div style={{ padding: "5px 0" }}>
                  <ChapterSelector
                    chapters={chapterData}
                    onSelectionChange={handleSelectionChange}
                    onIsLockedClick={onIsLockedClick}
                  />
                </div>
              </div>
            )}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              margin: "10px 0",
            }}
          >
            <div style={{ width: "fit-content" }}>
              <Button
                id=""
                type="button"
                label={"Auto Paper Generate"}
                disabled={buttonDisabled}
                onClick={onAutoGenerateClick}
                icon={
                  selectedDrpData?.isBluePrint?.name == "Yes" &&
                    chapterData?.isLocked ? (
                    <Lock className="w-5 h-5 text-white-400" />
                  ) : (
                    ""
                  )
                }
              />
            </div>
          </div>
        </>
      )}

      <PrintModel
        isModelOpen={isModelOpen}
        setisModelOpen={setisModelOpen}
        handleModelClose={handleModelClose}
        modelCall={modelCall}
        setModelCall={setModelCall}
        headerPath={HeadersPath.AutoGenerate}
        isEdit={"false"}
      />
      <SubjectPurchase
        isModelOpen={isPurchaseModelOpen}
        setIsPurchaseModelOpen={setIsPurchaseModelOpen}
        selectedDrpData={selectedDrpData}
        onPaymentSuccess={onPaymentSuccess}
      />
    </div >
  );
};

export default AutoGenerate;
